import {Caption} from '@contentlab/types/captions';
import {getTimedWords, getCurrentWord} from './WordTimingProcessor';
import {WrappedTextResult} from './types';

export const wrapTextRegular = (
  context: CanvasRenderingContext2D,
  caption: Caption,
  maxWidth: number
): WrappedTextResult => {
  const words = caption.text.split(' ');
  const lines: string[] = [];
  let currentLine = '';

  words.forEach((word) => {
    const testLine = currentLine ? `${currentLine} ${word}` : word;
    if (context.measureText(testLine).width > maxWidth && currentLine) {
      lines.push(currentLine);
      currentLine = word;
    } else {
      currentLine = testLine;
    }
  });

  if (currentLine) lines.push(currentLine);

  return {
    lines: lines.length > 0 ? lines : [caption.text],
    start: caption.start,
    end: caption.end,
  };
};

export const wrapTextWordByWord = (
  context: CanvasRenderingContext2D,
  caption: Caption,
  maxWidth: number,
  currentTime: number
): WrappedTextResult => {
  const words = getTimedWords(caption);
  const currentWord = getCurrentWord(words, currentTime);

  return currentWord
    ? {
        lines: [currentWord.text],
        start: currentWord.start,
        end: currentWord.end,
      }
    : {
        lines: [''],
        start: caption.start,
        end: caption.end,
      };
};
